/* Etern Homme · Landings de producto */
(function () {
  if (window.EH_PDP) return;
  window.EH_PDP = true;

  /* Galería: miniaturas y aviso de imagen ilustrativa */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('.ehp .thumbs button');
    if (!t) return;
    var g = t.closest('.gallery'), main = g.querySelector('.main img');
    main.src = t.getAttribute('data-src');
    main.srcset = t.getAttribute('data-srcset') || '';
    main.alt = t.getAttribute('data-alt') || '';
    g.querySelectorAll('.thumbs button').forEach(function (x) { x.setAttribute('aria-current', x === t ? 'true' : 'false'); });
    g.querySelector('.main').classList.toggle('whole', t.getAttribute('data-whole') === 'true');
    var note = g.querySelector('.illus-note');
    if (note) note.hidden = t.getAttribute('data-illus') !== 'true';
  });

  /* Selector "¿Mejor en kit?" */
  function pick(o) {
    var root = o.closest('.ehp-main');
    root.querySelectorAll('.opt').forEach(function (x) { x.setAttribute('aria-checked', x === o ? 'true' : 'false'); x.tabIndex = x === o ? 0 : -1; });
    var btns = document.querySelectorAll('[data-ehp-atc]');
    btns.forEach(function (b) {
      b.setAttribute('data-variant', o.getAttribute('data-variant'));
      var label = b.getAttribute('data-label');
      b.textContent = label ? label + ' · ' + o.getAttribute('data-price') : b.textContent;
      if (o.getAttribute('data-available') === 'false') { b.disabled = true; b.textContent = 'Agotado'; } else b.disabled = false;
    });
    /* Landing de kit: el precio grande sigue al kit elegido */
    var pl = root.querySelector('.priceline');
    if (pl) {
      var here = o.classList.contains('here');
      pl.querySelector('.now').textContent = o.getAttribute('data-price');
      pl.querySelectorAll('s, .save, .perday').forEach(function (x) { x.hidden = !here; });
    }
    /* Otro pack: tarjeta al momento; contra reembolso desde la ficha de ese pack */
    var pay = root.querySelector('.eh-pay'), other = !o.classList.contains('here');
    if (pay) {
      pay.classList.toggle('is-other', other);
      var co = pay.querySelector('.eh-cod-other');
      if (co) { co.hidden = !other; if (other) co.href = o.getAttribute('data-url') + '#comprar'; }
    }
    var st = document.querySelector('.ehp-stick');
    if (st) {
      st.querySelector('.n span').textContent = o.getAttribute('data-name');
      st.querySelector('.n small').textContent = o.getAttribute('data-price');
      var im = st.querySelector('img'); if (im && o.getAttribute('data-img')) im.src = o.getAttribute('data-img');
    }
  }
  document.addEventListener('click', function (e) { var o = e.target.closest('.ehp .opt'); if (o && o.tagName !== 'A') pick(o); });
  /* Copiar código de bienvenida */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-eh-copy]'); if (!b) return;
    var c = b.getAttribute('data-eh-copy'), done = function () { b.textContent = 'Copiado ✓'; setTimeout(function () { b.textContent = 'Copiar'; }, 1800); };
    if (navigator.clipboard) navigator.clipboard.writeText(c).then(done, done); else done();
  });
  document.addEventListener('keydown', function (e) {
    var o = e.target.closest && e.target.closest('.ehp .opt'); if (!o || o.tagName === 'A') return;
    var all = [].slice.call(o.parentNode.querySelectorAll('div.opt')), i = all.indexOf(o);
    var d = (e.key === 'ArrowDown' || e.key === 'ArrowRight') ? 1 : (e.key === 'ArrowUp' || e.key === 'ArrowLeft') ? -1 : 0;
    if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); pick(o); return; }
    if (d) { e.preventDefault(); var n = all[(i + d + all.length) % all.length]; pick(n); n.focus(); }
  });


  /* Pagar con tarjeta: pago directo solo de este producto (enlace permanente del carrito).
     No suma al carrito, así que volver atrás y pulsar de nuevo no duplica unidades,
     y si no hay stock el propio pago de Shopify lo avisa. */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ehp-checkout]'); if (!b) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (b.disabled) return;
    var id = parseInt(b.getAttribute('data-variant'), 10); if (!id) return;
    b.setAttribute('aria-busy', 'true');
    window.location.assign('/cart/' + id + ':1');
  }, true);
  window.addEventListener('pageshow', function () { document.querySelectorAll('[data-ehp-checkout][aria-busy]').forEach(function (b) { b.removeAttribute('aria-busy'); }); });

  /* Barra fija: sube al bloque de pago */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-ehp-goto]'); if (!a) return;
    var t = document.getElementById('comprar'); if (!t) return;
    e.preventDefault();
    t.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
  });

  /* Pestañas (Activar / Aplicar / Repetir) e interruptor Barba / Cabello */
  function selectTab(t) {
    var root = t.closest('[data-ehk-tabs]'); if (!root) return;
    var tabs = [].slice.call(root.querySelectorAll('[role="tab"]'));
    tabs.forEach(function (x) {
      var on = x === t;
      x.setAttribute('aria-selected', on ? 'true' : 'false'); x.tabIndex = on ? 0 : -1;
      var id = x.getAttribute('aria-controls');
      var ps = [].slice.call(root.querySelectorAll('[data-tab]')).filter(function (p) { return p.getAttribute('data-tab') === id; });
      var panel = document.getElementById(id); if (panel) ps.push(panel);
      ps.forEach(function (p) {
        p.hidden = !on;
        var v = p.tagName === 'VIDEO' ? p : p.querySelector('video');
        if (v && on) loadVid(v);
        if (v) { if (on) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } else v.pause(); }
      });
    });
  }
  document.addEventListener('click', function (e) { var t = e.target.closest('[data-ehk-tabs] [role="tab"]'); if (t) selectTab(t); });
  document.addEventListener('keydown', function (e) {
    var t = e.target.closest && e.target.closest('[data-ehk-tabs] [role="tab"]'); if (!t) return;
    var all = [].slice.call(t.parentNode.querySelectorAll('[role="tab"]')), i = all.indexOf(t);
    var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
    if (d) { e.preventDefault(); var n = all[(i + d + all.length) % all.length]; selectTab(n); n.focus(); }
  });

  /* Barra fija: visible mientras el botón principal no está en pantalla.
     En móvil también al entrar, para que el precio y "Comprar" se vean sin bajar. */
  function initStick() {
    var st = document.querySelector('.ehp-stick'), main = document.querySelector('.ehp-main [data-ehp-atc]');
    if (!st || !main || !('IntersectionObserver' in window)) return;
    var mobile = window.matchMedia('(max-width: 959px)');
    new IntersectionObserver(function (es) {
      es.forEach(function (en) { var on = !en.isIntersecting && (mobile.matches || en.boundingClientRect.top < 0); st.classList.toggle('on', on); st.setAttribute('aria-hidden', on ? 'false' : 'true'); });
    }).observe(main);
  }

  /* Vídeo: saltar un tramo (data-skip="inicio,fin") */
  function skipRange(v) {
    var r = (v.getAttribute('data-skip') || '').split(',').map(Number);
    if (r.length !== 2 || isNaN(r[0]) || isNaN(r[1]) || r[1] <= r[0]) return;
    function check(t) { if (t >= r[0] && t < r[1]) v.currentTime = r[1]; }
    if ('requestVideoFrameCallback' in v) {
      var loop = function (now, meta) { check(meta.mediaTime); v.requestVideoFrameCallback(loop); };
      v.requestVideoFrameCallback(loop);
    }
    v.addEventListener('timeupdate', function () { check(v.currentTime); });
  }

  /* Círculos de "En números": se rellenan al aparecer */
  function initRings() {
    var rs = document.querySelectorAll('[data-ehk-rings]');
    if (!rs.length || !('IntersectionObserver' in window)) return;
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.remove('pre'); io.unobserve(en.target); } });
    }, { threshold: .35 });
    rs.forEach(function (r) { r.classList.add('pre'); io.observe(r); });
  }

  /* Vídeos: se descargan solo al acercarse a la pantalla (ahorra datos en móvil) */
  function loadVid(v) { if (v.dataset.src && !v.getAttribute('src')) { v.src = v.dataset.src; } }
  function initLazyVideos() {
    var vs = document.querySelectorAll('.ehp video[data-src]'); if (!vs.length) return;
    if (!('IntersectionObserver' in window)) { vs.forEach(loadVid); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (!en.isIntersecting) return;
        var v = en.target; io.unobserve(v); loadVid(v);
        if (v.hasAttribute('autoplay') && !(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      });
    }, { rootMargin: '300px 0px' });
    vs.forEach(function (v) { if (v.offsetParent !== null || v.closest('.m')) io.observe(v); });
  }

  function boot() {
    initStick();
    initLazyVideos();
    initRings();
    document.querySelectorAll('.ehp video[data-skip]').forEach(skipRange);
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) {
      document.querySelectorAll('.ehp video[autoplay]').forEach(function (v) { v.pause(); v.controls = true; });
    }
    var first = document.querySelector('.ehp .opt[aria-checked="true"]'); if (first) pick(first);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
